package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import br.com.htms.inspeccaocampo.export.PlanilhaModulo
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton

/** "Planilha Excel" do módulo: abas de dados com filtro + dashboard; a cópia vai para a pasta do módulo no SharePoint. */
@Composable
fun BotaoPlanilha(controller: AppController, modulo: PlanilhaModulo) {
    val gerando by controller.planilhaGerando.collectAsState()
    PortalOutlinedButton(onClick = { controller.baixarPlanilhaModulo(modulo) }, enabled = gerando == null) {
        Text(if (gerando == modulo) "Gerando planilha..." else "Planilha Excel")
    }
}
